import { ExclamationCircleFilled } from "@ant-design/icons";
import React from "react";

export const AlertIconCell = React.memo(({ alertId }: { alertId?: number }) => {
  if (!alertId) return null;

  return <ExclamationCircleFilled style={{ fontSize: 18 }} />;
});
